// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_EncerramentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /rede/encerramento/:id, POST /rede/encerramento e /rede/encerramento/concluir — um encerramento com o checklist (Full). */
import type { Rede_EncerramentoItemRow } from './Rede_EncerramentoItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_EncerramentoResponseDados {
id: number
nome: string
nome_registrado: string
origem: string
situacao: string
a_conferir: boolean
itens: Rede_EncerramentoItemRow[]
pendentes: number
atualizado_por: string
atualizado_em: string
unidade?: string
divergencia?: string
distrato?: string
distrato_em?: string
observacao?: string
conferencia_juridico?: string
destino?: string
novo_franqueado?: string
concluido_em?: string
concluido_por?: string
}

export type Rede_EncerramentoResponse = ApiResponse<Rede_EncerramentoResponseDados>;

registerResponseContract('Rede_EncerramentoResponse', {
  id:                   { type: 'number',  required: true },
  nome:                 { type: 'string',  required: true },
  nome_registrado:      { type: 'string',  required: true },
  origem:               { type: 'string',  required: true },
  situacao:             { type: 'string',  required: true },
  a_conferir:           { type: 'boolean', required: true },
  itens: {
    type: 'array',
    required: true,
    items: {
      item:       { type: 'string',  required: true },
      rotulo:     { type: 'string',  required: false },
      situacao:   { type: 'string',  required: true },
      observacao: { type: 'string',  required: false },
    },
  },
  pendentes:            { type: 'number',  required: true },
  atualizado_por:       { type: 'string',  required: true },
  atualizado_em:        { type: 'string',  required: true },
  unidade:              { type: 'string',  required: false },
  divergencia:          { type: 'string',  required: false },
  distrato:             { type: 'string',  required: false },
  distrato_em:          { type: 'string',  required: false },
  observacao:           { type: 'string',  required: false },
  conferencia_juridico: { type: 'string',  required: false },
  destino:              { type: 'string',  required: false },
  novo_franqueado:      { type: 'string',  required: false },
  concluido_em:         { type: 'string',  required: false },
  concluido_por:        { type: 'string',  required: false },
})
